let _ = t => t,
  _t;
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EN } from 'pricing-pages-lib/constants/Languages';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import styled from 'styled-components';
import { getCaseStudies } from '../../constants/case-studies/CaseStudiesConfig';
import { useAppSelector } from '../../reducers';
import { navItemForProductLineSelector } from '../../selectors/RoutingSelectors';
import { Section, SectionHeader, SectionTitle } from '../common/SharedComponents';
import Case from './Case';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Cases = styled.div.withConfig({
  displayName: "CaseStudies__Cases",
  componentId: "cpv4tf-0"
})(["display:grid;grid-template-columns:repeat(2,1fr);grid-column-gap:24px;padding-left:4px;padding-right:4px;", ""], breakpoint.tablet(_t || (_t = _`
    grid-template-columns: 1fr;
  `)));
const CaseStudies = ({
  productLine,
  tab
}) => {
  const navItem = useAppSelector(state => navItemForProductLineSelector(state, productLine));
  if (I18n.lang !== EN) return null;
  const caseStudies = getCaseStudies({
    navItem,
    tab
  });
  return /*#__PURE__*/_jsxs(Section, {
    "data-selenium-id": "case-studies-container",
    children: [/*#__PURE__*/_jsx(SectionHeader, {
      children: /*#__PURE__*/_jsx(SectionTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "case-studies.title"
        })
      })
    }), /*#__PURE__*/_jsx(Cases, {
      children: caseStudies.map(({
        caseStudyKey,
        href,
        logo,
        price
      }) => {
        return /*#__PURE__*/_jsx(Case, {
          caseStudyKey: caseStudyKey,
          href: href,
          logo: logo,
          price: price
        }, caseStudyKey);
      })
    })]
  });
};
export default CaseStudies;